import { render, staticRenderFns } from "./16_PromptMediaQuestion.vue?vue&type=template&id=bafa6bd2&scoped=true&"
import script from "./16_PromptMediaQuestion.vue?vue&type=script&lang=js&"
export * from "./16_PromptMediaQuestion.vue?vue&type=script&lang=js&"
import style0 from "./16_PromptMediaQuestion.vue?vue&type=style&index=0&id=bafa6bd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafa6bd2",
  null
  
)

export default component.exports